import React, { useState } from 'react'
import bannerIcon from "../../assets/icons/mediaIcons/banner 1.png"
import ArticleIcon from "../../assets/icons/mediaIcons/article 1.png"
import newspaper from "../../assets/icons/mediaIcons/newspaper 1.png"
import { ADMIN_PAGE_LABELS } from "../../navigation/adminNavigation"
const ArticleHooks = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    const [selectedTeamId, setSelectedTeamId] = useState(null);
    const [selectedTeamName, setSelectedTeamName] = useState(null);
  
    const handleSelect = (teamId) => {
      const selectedTeam = teams.find(team => team.id === teamId);
      setSelectedTeamId(teamId);
      setSelectedTeamName(selectedTeam.name);
    };

    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageChange = (event) => {
      const file = event.target.files[0];
      setSelectedImage(file);
    };


  
    const teams = [
      { id: 1, name: 'Team A' , nameAr: 'فريق ب' },
      { id: 2, name: 'Team B'  , nameAr: 'فريق ب' },
      { id: 3, name: 'Team C'  , nameAr: 'فريق ب'}
    ];
  
    const [search, setSearch] = useState(false)
  
  
    const NavItems = [
      { name: ADMIN_PAGE_LABELS.appBanners, to: "/media/banner", icon: bannerIcon },
      { name: "Article", to: "/media/article", icon: ArticleIcon },
      { name: "Project News", to: "/media/projectnews", icon: newspaper },
    ];
  
  
    return {
      NavItems,
      setSearch,
      handleShow,
      teams,
      show,
      handleClose,
      handleSelect,
      selectedTeamName,
      handleImageChange,
    }
}

export default ArticleHooks
